<template>
  <div class="text-input" :class="{ showOnly }">
    <input
      v-model="model"
      :class="{ isError: error, hasIcon: icon }"
      :placeholder="placeholder"
      v-bind="$attrs"
      v-on="listeners"
    />
    <div
      v-if="showOnly"
      class="input"
      :class="{ isError: error, hasIcon: icon, placeholder: !value, hasPrice: !!price }"
      v-on="listeners"
    >
      <p class="ellipsis">{{ value || placeholder }}</p>
      <p v-if="price" class="price">{{ $n(price, 'currency') }}{{ tax === 0 ? '' : `(${taxType})` }}</p>
    </div>
    <div v-if="icon" class="icon">
      <component :is="icon" />
    </div>
  </div>
</template>

<script>
/**
 * テキスト入力
 *
 * `<input type="text">` をラップしており、その全ての props を使用できます
 */
export default {
  name: 'TextInput',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    /** 入力値 (v-model) */
    value: { type: [String, Number], default: null },
    /** プレースホルダ */
    placeholder: { type: String, default: null },
    /** エラー表示 */
    error: { type: Boolean, default: false },
    /** アイコン */
    icon: { type: Object, default: null },
    /** 表示のみ */
    showOnly: { type: Boolean, default: false },
    /** 金額 */
    price: { type: Number, default: null },
    /** 税 */
    tax: { type: Number, default: null },
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        /**
         * 文字入力
         * @event input
         * @type {string}
         */
        this.$emit('input', value)
      },
    },
    listeners() {
      return {
        ...this.$listeners,
        input: () => {},
        change: e => {
          /**
           * 値変更
           * @event change
           * @type {string}
           */
          this.$emit('change', e.target.value)
        },
      }
    },
    taxType() {
      return this.$t(`tax[${this.tax}]`)
    },
  },
}
</script>

<style lang="postcss" scoped>
.text-input {
  position: relative;
}

input,
.input {
  align-items: center;
  appearance: none;
  background-color: var(--white);
  border: 1px solid var(--form-border-color);
  border-radius: 4px;
  box-sizing: border-box;
  color: var(--text-color);
  cursor: inherit;
  display: flex;
  height: 48px;
  line-height: 23px;
  outline: 0;
  padding: 0 16px;
  width: 100%;

  &.hasIcon {
    padding-right: 36px;
  }

  &.hasPrice {
    align-items: baseline;
    flex-direction: column;
    height: 58px;
    justify-content: center;
  }

  &:disabled,
  &:disabled + .input {
    background: var(--mostly-white-2);
    color: var(--gray);
  }

  &::placeholder,
  &.placeholder {
    color: var(--gray);
  }

  &::-ms-clear {
    display: none;
  }

  &.isError {
    background: var(--light-grayish-red);
    border-color: var(--bright-red-1);
  }
}

.showOnly {
  overflow: hidden;
  & input {
    display: none;
  }
}

.ellipsis {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.icon {
  align-items: center;
  display: flex;
  height: 100%;
  position: absolute;
  right: 8px;
  top: 0;
}

.price {
  font-size: 12px;
}
</style>
